import React, { useEffect } from "react";
import { makeStyles } from '@mui/styles';
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import Slider from "react-slick";
import QrCodeIcon from '@mui/icons-material/QrCode';
import AndroidIcon from '@mui/icons-material/Android';
import Dialog from '@mui/material/Dialog';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import TextField from '@mui/material/TextField';
import { alpha, styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import styled_components from "styled-components";
import CircleIcon from '@mui/icons-material/Circle';

import {WECHAT_LOGIN_URL,HOME_TITLE,MODEL_COLOR} from '../../../configs/constants'
import {company_name,loading,search_num} from '../../../actions/plan'
import { wechat_web_login } from '../../../actions/user';

import { AllTop_img, AppLoad_image, WebLoad_image } from './onLoad_image';
import bh_xcx_2 from '../../../static/image/bh_xcx_2.jpg'
import kuai_engine from '../../../static/image/kuai_engine.jpg'

import accountant_icon from '../../../static/icon/accountant_icon.png'
import tax_icon from '../../../static/icon/tax_icon.png'

import logo from '../../../static/logo/kuai_logo.jpg';
import white_logo from '../../../static/logo/logo_1.png';
import shui_engine_logo from '../../../static/logo/shui_engine.png';
import tax_shui_bai from '../../../static/logo/shui_bai.jpg'
import left_arrows from '../../../static/image/left_arrows.png'

const _ = require('micro-dash');
makeStyles((theme) => ({
    slickUl: {
        '& li': {
            width: '30px !important',
            height: '15px !important',
            paddingTop: '5px !important',

        },
        '& .slick-active': {
            margin: '0 8px !important',
            '& div': {
                background: '#fff !important',
                padding: '6px 15px !important',
                margin: '0 5px !important'
            }
        }
    }
}));

function SimpleSlider() {
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        accessibility: false,
        arrows: false,
        // autoplay: true,
        pauseOnDotsHover: true,
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    return (
        <Slider {...settings}>
            <div>
                <Link to='/initial/intro'>
                    <div style={{ color: '#fff' }}>
                        <h1 style={{ fontSize: 36 }}>博槐互联网科技</h1>
                        <div style={{ fontSize: 19, minWidth: '400px' }}>
                        千山起，万潮生。动千山智能体的愿景是帮助企业用户动用成千上万个智能体（千山）为助手，搭上生成式人工智能的浪潮，来为企业内部降本增效，也为企业外部的客户提供生成式人工智能服务。
                        </div>
                    </div>
                </Link>
            </div>
        </Slider>
    );
}




const useStyles = makeStyles((theme) => ({
    root: {
        padding: "0px  !important",
        margin: 0,
        maxWidth: '100%',
        overflowX: 'hidden'
    },
    searchClickButton:{
        backgroundColor:"rgb(0,0,0,0.35) !important",
        color: 'rgba(255,255,255,0.7) !important',
        fontSize: '14px !important',
        paddingInline: '15px !important',
        padding:'8px 0 !important',
        marginInline: '4px !important',
        borderRadius:'16px !important',
        '&:hover': {
            backgroundColor: 'rgb(0,0,0,0.35) !important',
        },
    },
    input:{
        // width: ${(p) => (p.isOpen ? "500px" : "287px")};
        height:'20px',
        borderRadius:'25px',
        transition: 'width 1s ease',
        '-webkit-transition':' width 1s',
        '&::placeholder' :{
            color: 'rgba(255,255,255,0.7)',
            opacity: 1, /* Firefox */
        },
        outline:'none',
        border:'none',
        padding:'10px',
        color:'#fff',
        background:'rgb(0,0,0,0.35)',
        paddingLeft:'35px'
    }
}));

const to_tax_planning = () => {
    // console.log(12)
    // const anchorElement = document.getElementById('tax_planning'); //找到滚动到的元素
    // if (anchorElement) {
    //     anchorElement.scrollIntoView({ behavior: 'smooth', block: 'start' }); // 让页面滚动到元素所在位置
    // }
}
const to_tax_accountant = () => {
    const anchorElement = document.getElementById('tax_accountant'); //找到滚动到的元素
    if (anchorElement) {
        anchorElement.scrollIntoView({ behavior: 'smooth', block: 'start' }); // 让页面滚动到元素所在位置
    }
}

function Initial() {
    console.log('location',window.location.host)
    const dispatch = useDispatch();
    const host_name=window.location.host
    const host_type=host_name.indexOf("huainor.com")
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [selectedValue, setSelectedValue] = React.useState('');
    const [qr_type,setQrtypoe]=React.useState('')
    const token = useSelector((state) => state.user.token);
    const query = new URLSearchParams(useLocation().search);
    const code = query.get("code");
    const login_state = query.get("state")
    const [needRedirect, setNeedRedirect] = React.useState(false);
    const [isCheckingCode, setIsCheckingCode] = React.useState(null);
    const search_nums = useSelector((state) => state.plan.search_nums);

    useEffect(() => {
        console.log(`code is ${code}, ischecking: ${isCheckingCode}, token: ${token}, ${_.isNil(isCheckingCode)}, ${_.isNil(token)}`)
        document.title = HOME_TITLE;

        if (!_.isNil(code)) {
            setIsCheckingCode(true);
            if (login_state == 'development') {

            } else {
                dispatch(wechat_web_login(code, (v) => setIsCheckingCode(v)));
            }
        };
        console.log(`code is ${code}, ischecking: ${isCheckingCode}, token: ${token}, ${_.isNil(isCheckingCode)}, ${_.isNil(token)}`)

        if (_.isNil(isCheckingCode)) {
            if (_.isNil(token)) {
                setNeedRedirect(true)
            }
        }

    }, []);

    useEffect(() => {
        if (isCheckingCode === false) {
            if (_.isNil(token)) {
                setNeedRedirect(true)

            }
        }

    }, [isCheckingCode]);


    const SimpleDialog=(props)=> {
        const { onClose, selectedValue, open } = props;
    
        const handleClose = () => {
            onClose(selectedValue);
        };
    
        return (
            <Dialog onClose={handleClose} open={open}>
                {
                    qr_type==1?<div style={{textAlign:'center',paddingTop:'10px',fontSize:'20px',fontWeight:'bold'}}>博槐税引擎</div>:<div style={{textAlign:'center',paddingTop:'10px',fontSize:'20px',fontWeight:'bold'}}>税务师引擎</div>
                }
                <img src={selectedValue} style={{ width: 300 }} alt='' />
            </Dialog>
        );
    }
    const SampleNextArrow=(props)=> {
        const { className, style, onClick } = props;
        return (
          <div
            // className={className}
            style={{ ...style, display: "block",right:'5%',top:'50%',position:'absolute',zIndex:99,cursor: 'pointer'}}
            onClick={onClick}
          ><ArrowForwardIosIcon style={{fontSize:40,color:'#666'}} /></div>
        );
      }
      const SamplePrevArrow=(props)=> {
        // console.log(props)
        const { className, style, onClick } = props;
        return (
          <div
            // className={className}
            style={{ ...style, display: "block",left:'5%',top:'50%',position:'absolute',zIndex:99,cursor: 'pointer' }}
            onClick={onClick}
          ><ArrowBackIosIcon style={{fontSize:40,color:'#666'}} /></div>
        );
      }
    const Shuilider=()=> {
        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            accessibility: false,
            // arrows: false,
            autoplay: false,
            pauseOnDotsHover: true,
            adaptiveHeight: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />
        };
        return (
            <Slider {...settings}>
                <div >
                    <h2 style={{ fontSize: 30, textAlign: 'center', margin: '60px 0', cursor: 'pointer' }} id='tax_planning' onClick={() => handleClickOpen(1)}>博槐税引擎小程序<QrCodeIcon style={{ marginLeft: 10, cursor: 'pointer' }} /></h2>
                    <div style={{ display: 'flex', padding: 20, paddingBottom: 70,justifyContent:'center' }}>
                        <AppLoad_image img_url={'https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/gif/phone_gif.gif'} />
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '12%' }}>
                            <img src={shui_engine_logo} style={{ width: 50, height: 50, marginTop: -150 }} />
                        </div>
                        <div style={{ width: '25.5%' }}>
                        <h4 style={{ fontWeight: 'bold', fontSize: 23, margin: 0 }}>一分钟自动税务筹划</h4>
                            <div style={{ color: '#536682', padding: '30px 0', width: 200, fontSize: 18 }}>在小程序内填写调查问卷后，系统会根据您的回答自动生成专属于您的一系列税务筹划方案</div>
                            <h4 style={{ fontWeight: 'bold', fontSize: 23, margin: 0 }}>税务知识库搜索</h4>
                            <div style={{ color: '#536682', padding: '30px 0', width: 200, fontSize: 18 }}>毫秒级搜索税务相关知识，了解税务筹划方案以及以往案例，身旁的便携税务筹划专家</div>
                            <h4 style={{ fontWeight: 'bold', fontSize: 23, margin: 0 }}>价廉物美，合理合法</h4>
                            <div style={{ color: '#536682', padding: '30px 0', width: 200, fontSize: 18 }}>以往动辄几万元的税务筹划方案只用十几块就可以无限次使用，还在等什么，快来试试吧！<QrCodeIcon onClick={() => handleClickOpen(1)}  style={{ cursor: 'pointer' }} /></div>
                        </div>
                    </div>
                </div>
                <div >
                    <h2 style={{ fontSize: 30, textAlign: 'center', margin: '60px 0', cursor: 'pointer' }} id='tax_planning' onClick={() => handleClickOpen(1)}>博槐税引擎小程序（企业家群体）<QrCodeIcon style={{ marginLeft: 10, cursor: 'pointer' }} /></h2>
                    <div style={{ display: 'flex', padding: 20, paddingBottom: 70,justifyContent:'center' }}>
                        <AppLoad_image img_url={'https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/gif/shui_tax_gif.gif'} />
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '12%' }}>
                            <img src={shui_engine_logo} style={{ width: 50, height: 50, marginTop: -150 }} />
                        </div>
                        <div style={{ width: '25.5%' }}>
                            <h4 style={{ fontWeight: 'bold', fontSize: 23, margin: 0 }}>在线资深税务专家接单</h4>
                            <div style={{ color: '#536682', padding: '30px 0', width: 200, fontSize: 18 }}>入驻平台的资深税务专家线上接单，可为企业提供税务筹划，已有税务筹划方案的风险排查等人工服务</div>
                            <h4 style={{ fontWeight: 'bold', fontSize: 23, margin: 0 }}>税务知识问答</h4>
                            <div style={{ color: '#536682', padding: '30px 0', width: 200, fontSize: 18 }}>上万条税务问题问答，开通会员后可免费提问税务实务问题</div>
                            <h4 style={{ fontWeight: 'bold', fontSize: 23, margin: 0 }}>合理合法，价格公允</h4>
                            <div style={{ color: '#536682', padding: '30px 0', width: 200, fontSize: 18 }}>平台会对税务专家提供的税务筹划方案进行二次审核与评估，杜绝灰色地带的税务筹划，人工服务价格远低于市场价<QrCodeIcon onClick={() => handleClickOpen(1)} style={{ cursor: 'pointer' }} /></div>
                        </div>
                    </div>
                </div>
            </Slider>
        );
    }

    const handleClickOpen = (e) => {
        if (e === 1) {
            setSelectedValue(bh_xcx_2);
        } else {
            setSelectedValue('https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/tax_agent_app/download_tax_agent.png');
        }
        setOpen(true);
        setQrtypoe(e)
    };

    const handleClose = () => {
        setOpen(false);

    };
    const [isOpen, setisOpen] = React.useState(false);
    const onSearchFocus= () => {
        setisOpen(true);
    };
    const  onSearchBlur= () => {
        // setisOpen(false);
    }
    //获得公司名
    const [value, setValue] = React.useState('');
    const plan_value=(e)=>{
        // console.log(e.target.value)
        setValue(e.target.value)
    }
    const search_company=()=>{
        if(_.isNil(token)){
            if(search_nums>0){
                alert('请先登录!')
            }else{
                // dispatch(loading())
                dispatch(company_name(value))
                dispatch(search_num())
            }
        }else{
            
            dispatch(company_name(value))
        }
    }
    return (
        <div className={classes.root}>
            <div>
                <div style={{ backgroundColor: '#4844f3', color: '#fff', width: '100%', height: 500, position: 'relative', display: 'flex', justifyContent: 'space-between', overflowX: 'clip' }}>
                    <div style={{ zIndex: 99, width: '55%', minWidth: '762px' }}>
                        <div style={{ display: 'flex' }}>
                            <div style={{ display: 'flex', padding: '20px', fontSize: 20 }}>
                                <div>
                                    <img src={white_logo} style={{ width: '26px', height: '26px', background: '#fff', borderRadius: '50%' }} alt="" />
                                </div>
                                <div style={{ paddingLeft: 8 }}>博槐互联网科技</div>
                            </div>
                            {/* onClick={() => window.location.href = 'http://101.35.94.104:3070'} */}
                            {/* <Link to='/tax' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width: '15%', fontSize: 15, lineHeight: '60px', cursor: "pointer", padding: '5px 8px', color: '#fff' }}>
                                <div >知识库</div>
                            </Link>
                            <Link to='/tax_accountant_lists' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width: '15%', fontSize: 15, lineHeight: '60px', cursor: "pointer", padding: '5px 8px', color: '#fff' }}>
                                <div >税务师资源</div>
                            </Link> */}
                            <Link to='/largemodel' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width: '15%', fontSize: 15, lineHeight: '60px', cursor: "pointer", padding: '5px 8px', color: '#fff' }}>
                                <div >动千山智能体</div>
                            </Link>
                            {/* <Link onClick={() => window.location.href = 'http://huainor.ac.cn'} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width: '15%', fontSize: 15, lineHeight: '60px', cursor: "pointer", padding: '5px 8px', color: '#fff' }}>
                                <div>Kuai引擎</div>
                            </Link> */}
                            <Link to='/initial/intro' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width: '15%', fontSize: 15, lineHeight: '60px', cursor: "pointer", padding: '5px 8px', color: '#fff' }}>
                                <div>产品介绍</div>
                            </Link>
                            {/* {
                                _.isNil(token)?<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width: '15%', fontSize: 15, lineHeight: '60px', cursor: "pointer", padding: '5px 8px', color: '#fff' }} onClick={() => window.location.href = WECHAT_LOGIN_URL}>
                                <div style={{ color: '#fff', }}>登录</div>
                                <div>
                                    <img src={left_arrows} alt="" style={{ width: 20, height: 20, paddingLeft: 8,paddingTop:'21px' }} />
                                </div>
                            </div>:''
                            } */}
                            
                        </div>
                        <div style={{ padding: '40px 50px', width: '500px' }}>
                            <SimpleSlider />
                        </div>
                        <div style={{ display: 'flex', padding:"0 50px", paddingTop: 0 }}>
                            {/* <Link onClick={() => window.location.href = 'http://101.35.94.104:3070'}> */}
                            <Link to='/largemodel' onClick={to_tax_planning} style={{ borderRadius: 25, cursor: "pointer", padding: '8px 0', background: '#fff', color: '#000000', width: 287, height: 33, textAlign: 'center', lineHeight: '40px', fontSize: 18, display: 'flex', flexDirection: "row", alignItems: 'center', justifyContent: 'center' }}>
                                <img src={tax_icon} style={{ width: 27 }} />
                                <div style={{ marginLeft: 10 }}>动千山智能体</div>
                            </Link>
                            {/* </Link> */}
                            {/* <Link onClick={() => window.location.href = 'http://huainor.ac.cn'}> */}
                            {/* <div onClick={to_tax_accountant} style={{ borderRadius: 25, cursor: "pointer", padding: '8px 0', marginLeft: 20, background: '#fff', color: '#000000', width: 287, height: 33, textAlign: 'center', lineHeight: '40px', fontSize: 18, display: 'flex', flexDirection: "row", alignItems: 'center', justifyContent: 'center' }}>
                                <img src={accountant_icon} style={{ width: 25 }} />
                                <div style={{ marginLeft: 10 }}>税务师接单平台</div>
                            </div> */}
                            {/* </Link> */}
                        </div>
                        <Link to='/largemodel' style={{margin:'30px 50px'}}>
                            <p style={{position:'relative',marginLeft:50,marginTop:30}}>
                                <SearchIcon style={{ fontSize: 25,position:'absolute',left:8,top:8,zIndex:99 ,color:'rgba(255,255,255,0.7)'}}/>
                                <input 
                                    className={classes.input} 
                                    // onFocus={onSearchFocus}
                                    // onBlur={onSearchBlur} 
                                    placeholder="动千山智能体"
                                    style={{width:isOpen?'70%':'287px'}}
                                    onChange={plan_value}
                                />
                                
                                {/* {
                                    isOpen?_.isNil(token)&&search_nums>0?<Button className={classes.searchClickButton} disableElevation onClick={search_company}>
                                    搜索
                                    </Button>:<Link to='/speedinessPlan'>
                                        <Button className={classes.searchClickButton} disableElevation onClick={search_company}>
                                            搜索
                                        </Button> 
                                    </Link>:''
                                } */}
                            </p>
                        </Link>
                    </div>
                    <div style={{ marginTop: -130, marginRight: -150, zIndex: 1, width: '45%' }}>
                        <AllTop_img img_url={'https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/gif/all_iphone.png'}></AllTop_img>
                    </div>
                </div>
                <div style={{ padding: '40px 50px 50px' }}>
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: 287, textAlign: 'center' }}>
                            <p style={{ fontSize: 17, }}>税引擎小程序</p>
                            <div>
                                <img src={bh_xcx_2} style={{ width: 160 }} alt='' />
                            </div>
                        </div>
                        <div style={{ width: 287, textAlign: 'center' }}>
                            <p style={{ fontSize: 17, width: 287 }}>税务师引擎</p>
                            <div >
                                <img src={'https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/tax_agent_app/download_tax_agent.png'} style={{ width: 160 }} alt='' />
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: 287 }}>
                            <div style={{ width: 160, background: '#000', height: 1, margin: '0 auto', marginTop: 11 }}></div>
                        </div>

                        <div>or</div>
                        <div style={{ width: 287 }}>
                            <div style={{ width: 160, background: '#000', height: 1, margin: '0 auto', marginTop: 11 }}></div>
                        </div>
                    </div>
                </div>

                
                <div>
                    <Shuilider/>
                    {/* <div style={{ display: 'flex', padding: 20, paddingBottom: 70, }}>
                        <AppLoad_image img_url={'https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/gif/phone_gif.gif'} />
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '12%' }}>
                            <img src={shui_engine_logo} style={{ width: 50, height: 50, marginTop: -150 }} />
                        </div>
                        <div style={{ width: '42.5%' }}>
                            <h4 style={{ fontWeight: 'bold', fontSize: 23, margin: 0 }}>税务知识库搜索</h4>
                            <div style={{ color: '#536682', padding: '30px 0', width: 200, fontSize: 18 }}>毫秒级搜索税务相关知识，了解税务筹划方案以及以往案例，身旁的便携税务筹划专家</div>
                            <h4 style={{ fontWeight: 'bold', fontSize: 23, margin: 0 }}>自动税务筹划调查问卷</h4>
                            <div style={{ color: '#536682', padding: '30px 0', width: 200, fontSize: 18 }}>在小程序内填写调查问卷后，根据您的回答自动生成专属于您的一系列税务筹划方案</div>
                            <h4 style={{ fontWeight: 'bold', fontSize: 23, margin: 0 }}>价廉物美的服务</h4>
                            <div style={{ color: '#536682', padding: '30px 0', width: 200, fontSize: 18 }}>以往动辄几万元的税务筹划方案只用十几块就可以无限次使用，还在等什么，快来试试吧！<QrCodeIcon onClick={() => handleClickOpen(1)} style={{ cursor: 'pointer' }} /></div>
                        </div>
                    </div> */}
                    <div>
                        <div style={{backgroundColor: MODEL_COLOR,color:'#fff'}}>
                            <h2 style={{ fontSize: 30, textAlign: 'center', margin: '60px 0',paddingTop:20 }} id='tax_accountant'>
                                税务师引擎
                                <QrCodeIcon onClick={() => handleClickOpen(2)} style={{ marginLeft: 10, cursor: 'pointer' }} />
                                <a style={{ marginLeft: 10 }} href="https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/tax_agent_app/tax_agent.apk">
                                    <AndroidIcon style={{color:'#fff'}} />
                                </a>
                            </h2>
                            <div style={{ display: 'flex', padding: 20, paddingBottom: 70,justifyContent:'center' }}>
                                <div style={{ width: '21%' }}>
                                    <h3 style={{ fontWeight: 'bold', fontSize: 23, margin: 0 }}>会计实务库搜索</h3>
                                    <div style={{  padding: '30px 0', width: 200, fontSize: 18 }}>毫秒级搜索会计实务相关知识，身旁的便携会计实务专家</div>
                                    <h3 style={{ fontWeight: 'bold', fontSize: 23, margin: 0 }}>价廉物美的服务</h3>
                                    <div style={{  padding: '30px 0', width: 200, fontSize: 18 }}>只用一块钱就可以在期限内无限次使用，还在等什么，快来试试吧！</div>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '12%' }}>
                                    <img src={tax_shui_bai} style={{ width: 50, height: 50, marginTop: -150,borderRadius:'50%' }} />
                                </div>
                                <AppLoad_image img_url={'https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/gif/tax_app.gif'} />
                            </div>
                        </div>
                        <div style={{ padding: 20, margin: '30px 0', paddingBottom: 90, marginBottom: 0 }}>
                            <h2>
                                <div style={{ textAlign: 'center', fontSize: 30, marginBottom: '100px' }}>博槐CRM</div>
                            </h2>
                            <div style={{ display: 'flex' }}>
                                <WebLoad_image img_url={'https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/gif/tax_agent.gif'} />
                                <div style={{ width: '30%', textAlign: 'center' }}>
                                    <h4 style={{ fontWeight: 'bold', fontSize: 23, margin: 0 }}>事务所最强获客工具</h4>
                                    <div style={{ padding: '20px 0', width: 300, fontSize: 18, margin: '0 auto', textAlign: 'left',color: '#536682' }}>
                                        <CircleIcon style={{color:'#666',fontSize:14,paddingRight:10}}/>
                                        博槐CRM向税务师/会计师事务所提供千万级别潜在客户信息，包括潜在客户对于税务合规化的兴趣指标，对特定税务筹划方案的兴趣，领取的税引擎税务合规化免费方案等。
                                    </div>
                                    <div style={{ padding: '10px 0', width: 300, fontSize: 18, margin: '0 auto', textAlign: 'left',color: '#536682' }}>
                                        <CircleIcon style={{color:'#666',fontSize:14,paddingRight:10}}/>
                                        事务所通过博槐CRM可拿到潜在客户的公司信息，联系方式，精确地理位置等信息，也可根据事务所地理位置进行周边潜在用户筛查与搜索。
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ padding: 20, margin: '30px 0', paddingBottom: 90, marginBottom: 0, backgroundColor: MODEL_COLOR }}>
                            <h2 style={{ textAlign: 'center', fontSize: 30, margin: '150px 0', color: '#fff', marginBottom: '100px' }}>博槐股税通搜索引擎</h2>
                            <div style={{ display: 'flex' }}>
                                <div style={{ width: '30%', color: '#fff', textAlign: 'center', paddingLeft: '15%' }}>
                                    <h3 style={{ fontWeight: 'bold', fontSize: 23, margin: 0 }}>Web端知识库搜索引擎</h3>
                                    <div style={{ padding: '30px 0', width: 200, fontSize: 18, margin: '0 auto', textAlign: 'left' }}>您也可以在Web端进行税务知识的毫秒级搜索，同时还可以进行多条件搜索，拼音搜索等</div>
                                </div>
                                <WebLoad_image img_url={'https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/gif/video_gif.gif'} />
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-around', backgroundColor: '#35363A', padding: '10px 20px' }}>
                    <div style={{ lineHeight: '70px' }}>
                        <div style={{ textAlign: 'left', color: '#fff', fontSize: 12, display: 'flex' }}>
                            <a href="https://beian.miit.gov.cn/" style={{ marginRight: 10, cursor: "pointer", width: '210px',color: '#fff' }}>
                                {
                                    host_type==-1?'京ICP备2021025663号-2':'京ICP备2021025663号-1'
                                }
                            </a>
                            <div style={{ width: '210px' }}>博槐（北京）互联网科技有限责任公司</div>
                        </div>
                        <div style={{ textAlign: 'left', color: '#fff', fontSize: 12, display: 'flex' }}>
                            <div style={{ marginRight: 10, width: '210px' }}>电话：18910186883</div>
                            <div style={{ width: '210px' }}>邮箱：zhuxihao@huainor.com</div>
                        </div>
                    </div>
                    <div style={{ paddingTop: '30px' }}>
                        <div>
                            <img src={'https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/web_content/web_content.png?time=' + parseInt((new Date().getTime() / 1000).toString())} style={{ width: 100 }} alt='' />
                        </div>
                        <div style={{ color: '#fff', fontSize: 12, textAlign: 'center' }}>加入我们</div>
                    </div>
                </div>
                <SimpleDialog
                    selectedValue={selectedValue}
                    open={open}
                    onClose={handleClose}
                />
            </div>
        </div>
    );
}

export default Initial;